export default __webpack_public_path__ + "static/media/BlueTreeCutebatman1.f74b0ffa.jpg";